Prism.languages.json = {
    'property': /"(?:\\.|[^|"])*"(?=\s*:)/ig,
    'string': /"(?!:)(?:\\.|[^|"])*"(?!:)/g,
    'number': /\b-?(0x[\dA-Fa-f]+|\d*\.?\d+([Ee][+-]?\d+)?)\b/g,
    'punctuation': /[{}[\]);,]/g,
    'operator': /:/g,
    'boolean': /\b(true|false)\b/gi,
    'null': /\bnull\b/gi
};

Prism.languages.jsonp = Prism.languages.json;



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/prismjs/components/prism-json.js
// module id = 1127
// module chunks = 1